import React, { useState, useEffect } from 'react';
import '../../App.css';
import axios from 'axios';
import Dashheader from '../Dash-header/Dashheader';
import Sidebar from '../dashboard/Sidebar';
import '../notification/notificationWrapp.css';
import rolling from '../../images/rollng.gif';
import round from '../../images/rounded-check-orange.svg';
import { END_URL } from '../../config';
import UserFooter from '../footer/UserFooter.jsx';
import { useNavigate } from "react-router-dom";


// Custom Confirmation Modal Component
function ConfirmationModal({ isOpen, onClose, onConfirm, message }) {
  if (!isOpen) return null;



  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>{message}</h3>
        <div className="button-cta">
          <button onClick={onClose} className="btn btn-secondary">Cancel</button>
          <button onClick={onConfirm} className="btn btn-primary">Confirm</button>
        </div>
      </div>
    </div>
  );
}

function NotificationWrapper() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [expanded1, setExpanded] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [notificationToDelete, setNotificationToDelete] = useState(null);
  const [dynamicContent, setDynamicContent] = useState(null);
  const [filterType, setFilterType] = useState('all');

  const [readFilter, setReadFilter] = useState('all'); // 'all', 'read', 'unread'
  const [userNotificationPrefs, setUserNotificationPrefs] = useState(null);

  const [clearAllModalOpen, setClearAllModalOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    fetchNotifications();
    fetchDynamicContent();
  }, []);

  const fetchNotifications = async () => {
    const token = sessionStorage.getItem('authToken');
    if (!token) return;

    setLoading(true);
    try {
      const response = await axios.get(`${END_URL}notifications`, {
        headers: { Authorization: `Bearer ${token}` },
      });

       console.log('Fetched notifications:', response.data.notification || []);
       
      setNotifications(response.data.notification || []);
      setError(null);
    } catch (error) {
      console.error('Error fetching notifications:', error);
      setError('Failed to fetch notifications. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const fetchDynamicContent = async () => {
    try {
      const response = await axios.get(`${END_URL}dynamic-page`);
      setDynamicContent(response.data.data);
    } catch (error) {
      console.error('Failed to fetch dynamic content:', error);
    }
  };

  const handleRemoveNotification = (id) => {
    setNotificationToDelete(id);
    setModalOpen(true);
  };

    const HandleAction = (page) => {
      navigate(`/${page}`);
    };

  const handleConfirmDelete = async () => {
    if (!notificationToDelete) return;
    const token = sessionStorage.getItem('authToken');
    if (!token) return;

    try {
      await axios.post(
        `${END_URL}notifications/${notificationToDelete}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setNotifications(prev => prev.filter(notif => notif.id !== notificationToDelete));
      setModalOpen(false);
    } catch (error) {
      console.error('Error deleting notification:', error);
      setError('Failed to delete notification. Please try again.');
      setModalOpen(false);
    }
  };
  const handleMarkAsRead = async (id) => {
    const token = sessionStorage.getItem('authToken');
    if (!token) return;
    try {
      await axios.post(`${END_URL}notifications/${id}/mark-read`, {}, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setNotifications(prev =>
        prev.map(n => (n.id === id ? { ...n, read: true } : n))
      );
    } catch (error) {
      console.error('Error marking notification as read:', error);
      setError('Failed to mark notification as read.');
    }
  };

  const handleMarkAll = async () => {
    const token = sessionStorage.getItem('authToken');
    if (!token) return;
    try {
      await axios.post(`${END_URL}noti/mark-all-read`, {}, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setNotifications(prev => prev.map(n => ({ ...n, read: true })));
    } catch (error) {
      console.error('Error marking all notifications as read:', error);
      setError('Failed to mark all as read.');
    }
  };

  const handleClearAll = async () => {
    const token = sessionStorage.getItem('authToken');
    if (!token) return;
    try {
      await axios.post(
        `${END_URL}notification/clear-all`,
        {}, // empty body
        { headers: { Authorization: `Bearer ${token}` } } // headers as third argument
      );
      setNotifications([]);
    } catch (error) {
      console.error('Error clearing notifications:', error);
      setError('Failed to clear notifications.');
    }
  };


  const handleToggleRead = async (id, currentReadStatus) => {
  const token = sessionStorage.getItem('authToken');
  if (!token) return;
  try {
    // Toggle logic: if read, mark as unread, else mark as read
    const url = currentReadStatus 
      ? `${END_URL}notifications/${id}/mark-unread` 
      : `${END_URL}notifications/${id}/mark-read`;

    await axios.post(url, {}, {
      headers: { Authorization: `Bearer ${token}` },
    });

    setNotifications(prev =>
      prev.map(n => n.id === id ? { ...n, read: !currentReadStatus } : n)
    );
  } catch (error) {
    console.error('Error toggling read status:', error);
    setError('Failed to update notification read status.');
  }
};




  const filteredNotifications = notifications.filter(notification => {

    const typeMatch = filterType === 'all' ? true : notification.notifytype === filterType;
    let readMatch = true;
    if (readFilter === 'read') readMatch = notification.read === 1 || notification.read === true;
    if (readFilter === 'unread') readMatch = notification.read === 0 || notification.read === false;

    return typeMatch && readMatch;
  });

  const renderIcon = (type) => {
    switch (type) {
      case 'actionrequired':
        return <span className="notification-icon warning">⚠️</span>;
      case 'information':
        return <span className="notification-icon info">ℹ️</span>;
      case 'success':
        return <span className="notification-icon success">✅</span>;
      default:
        return null;
    }
  };

  // Notification background styles
  const getNotifClass = (type) => {
    switch (type) {
      case 'actionrequired': return 'notfy-action';
      case 'information': return 'notfy-info';
      case 'success': return 'notfy-success';
      default: return '';
    }
  };


  useEffect(() => {
    const fetchUserPrefs = async () => {
      const token = sessionStorage.getItem('authToken');
      if (!token) return;
      try {
        const response = await axios.get(`${END_URL}user/notification-preferences`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.data.preferences) {
          setUserNotificationPrefs(response.data.preferences);
        }
      } catch (error) {
        console.error('Failed to fetch user notification preferences:', error);
      }
    };

    fetchUserPrefs();
    fetchNotifications();
    fetchDynamicContent();
  }, []);



  return (
    <div className="dashboard-container full-width">
      <Dashheader />
      <div className="container">
        <div className={`row main-row expanded ${expanded1 ? 'mainmenu' : ''}`}>
          <div className="col-12 col-sm-12 col-md-3 col-lg-3">
            <div className="dashboard-side-div">
              <Sidebar />
              <a href="#" className="expand-btn" onClick={(e) => {
                e.preventDefault();
                setExpanded(!expanded1);
              }}><span></span></a>
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-9 col-lg-9">
            <main className="content">
              <div className="dashbord-first">
                  <div dangerouslySetInnerHTML={{ __html: dynamicContent?.notification1 }} />
                </div>
              <div className="nofty-wrapp content-card ">
                <div className="card-header">
                  <h2>Your Alerts</h2>
                  <div className="notification-filters ">
                  <select
                    id="filterTypeSelect"
                    className="form-control w-auto"
                    value={filterType}
                    onChange={e => setFilterType(e.target.value)}
                  >
                    <option value="all">All Types</option>
                    <option value="actionrequired">Action Required</option>
                    <option value="information">Information</option>
                    <option value="success">Success</option>
                  </select>

                  <select
                    id="readFilterSelect"
                    className="form-control w-auto"
                    value={readFilter}
                    onChange={e => {
                      setReadFilter(e.target.value);
                      console.log('Read filter changed to:', e.target.value);
                    }}
                  >

                    <option value="all">All</option>
                    <option value="read">Read Only</option>
                    <option value="unread">Unread Only</option>
                  </select>

                  <button className="btn btn-primary" onClick={handleMarkAll}>Mark All as Read</button>
                 <button className="btn btn-danger" onClick={() => setClearAllModalOpen(true)}>Clear All</button>

                  </div>
                </div>

                {error && <div className="alert alert-danger">{error}</div>}
                <div className="notfy-row row">
                  <div className="-col-md-12">
                    {loading ? (
                      <div className="notfy-col1">
                        <img src={rolling} className="load-img" alt="loading" />
                      </div>
                      
                    ) : filteredNotifications.length > 0 ? (
                      filteredNotifications.map((item) => (
                        <div className={`notfy-col1 ${getNotifClass(item.notifytype)}`} key={item.id}>
                          <div className="notfy-head d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center gap-2">
                              {renderIcon(item.notifytype)}
                              <h3>{item.title}</h3>
                            </div>
                            <h5>{item.created_date}</h5>
                          </div>
                          <div className="notfy-conten">
                            <p>{item.description}</p>
                          </div>
                          <div className="notification-type-label">
                            <span className={`badge ${item.read ? 'bg-success' : 'bg-warning'}`}>
                              {item.read ? 'Read' : 'Unread'}
                            </span>
                          </div>

                                                  <div className="d-flex gap-2 mt-2">
                            <button
                              className={`btn btn-outline-primary btn-sm-${item.read ? 'warning' : 'primary'} btn-sm`}
                              onClick={() => handleToggleRead(item.id, item.read)}
                            >
                              {item.read ? 'Mark as Unread' : 'Mark as Read'}
                            </button>

                            {item.actiontext && (
                              
                              <button
                                className="btn btn-outline-danger btn-sm"
                                onClick={() => HandleAction(item.pagelink)}
                              >
                                {item.actiontext}
                              </button>

                            )}

                          </div>

                        </div>
                      ))
                    ) : (
                      <div className="notfy-col1">
                        <div className="notfy-head">
                          <h3>No Notifications Found</h3>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <UserFooter />
            </main>
          </div>
        </div>
      </div>
      <ConfirmationModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onConfirm={handleConfirmDelete}
        message="Do you want to remove this notification?"
      />

      <ConfirmationModal
  isOpen={clearAllModalOpen}
  onClose={() => setClearAllModalOpen(false)}
  onConfirm={() => {
    handleClearAll();
    setClearAllModalOpen(false);
  }}
  message="Are you sure you want to clear all notifications?"
/>


    </div>
  );
}

export default NotificationWrapper;
